import type {ValuationData} from "@reva/shared/valuation-data";
import type {RevaValuationPurpose} from "@reva/shared/valuation-purpose";

import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";

/**
 * Zweckwechsel einer REVA-ID (#19481, POST {@link RevaApi.PATH_VALUATIONS}/{id}/changePurpose), z. B. eine
 * Research-Abfrage in eine Bewertung umwandeln. REVA-ID, Eingaben und Lebenszyklus bleiben erhalten. Idempotent: ist
 * der Zielzweck schon gesetzt, ändert das Backend nichts. Ohne das Recht des Zielzwecks 403, ein nicht erlaubter
 * Wechsel 409. Liefert die Bewertung wie ein Laden.
 */
export class ChangePurposeApiInterface extends SimpleApiInterface<ValuationData> {
    constructor(
        private readonly revaId: string,
        private readonly purpose: RevaValuationPurpose,
    ) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_VALUATIONS, this.revaId, RevaApi.PATH_VALUATION_CHANGE_PURPOSE]);
    }

    protected buildPayload(): object {
        return {purpose: this.purpose};
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<ValuationData> {
        return executor.fetchPOST(url, credentials, this.buildPayload());
    }
}
